import { FoodService } from "@/Application/services/food/food"
import { Api } from "@/Instructure/configs/api"
import { useMemo } from "react"
import { useQuery } from "react-query"
import { toast } from "react-toast"
import { container } from "tsyringe"

export const useGetInfo = () => {

    const foodService = useMemo(() => container.resolve(FoodService), [])

    return useQuery({
        queryKey: [Api.Food.getInfo],
        queryFn: () => {
            return foodService.getInfo()
        },
        onError: (err) => {
            toast.error('خطایی رخ داده لطفا بعدا امتحان نمایید')
        }
    })
}